export default "__VITE_ASSET__BkGEV7tU__"